export const locale = {
    'CONSISTENCY' : {
        'TITLE' : 'Передача заказа',
        'MESSAGE' : 'Заказ не согласован с Заказчиком. Необходимо согласовать заказ перед передачей исполнителю.',
        'CONFIRM' : 'Согласовать',
        'DECLINE' : 'Отмена',
    },
};
